import { lazy, Suspense } from "react";
import HeroSection from "../../components/HeroSection";
import SEO from "../../components/SEO";
import { pageSEOData } from "../../data/seoData";
import {
  createDoctorSchema,
  createMedicalBusinessSchema,
} from "../../utils/seo";

// Lazy load heavy components
const MedicineSection = lazy(() => import("../../components/MedicineSection"));
const IgniteRF = lazy(() => import("../../components/IgniteRF"));
const DualVideoSection = lazy(() => import("../../components/DualVideo"));
const DoctorIntro = lazy(() => import("../../components/DrGamIntro"));
const EarthScrollSection = lazy(() => import("../../components/earth/earth"));
const Questions = lazy(() => import("../../components/Questions"));

// Loading fallback component
const LoadingFallback = () => (
  <div className="flex items-center justify-center py-20">
    <div className="animate-pulse text-gray-400">Chargement...</div>
  </div>
);

const HomePage: React.FC<{}> = () => {
  const seo = pageSEOData.home;

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        ogImage={seo.ogImage}
        structuredData={[createDoctorSchema(), createMedicalBusinessSchema()]}
      />
      <div className="max-w-7xl mx-auto ">
        <HeroSection />
      </div>
      <Suspense fallback={<LoadingFallback />}>
        <MedicineSection />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <IgniteRF />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <DualVideoSection />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <DoctorIntro />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <EarthScrollSection />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <Questions />
      </Suspense>
    </>
  );
};
export default HomePage;
